module.exports = __webpack_public_path__ + "static/media/0222_IMG_LES_MURS_METRO_DIAMANTO_BRILLANT_TALCO_VERTICALE.7f3a5153.webp";